import React from "react";
import LoaderState from "../../../store/Loader/LoaderStateManage.store";
import { LuLoaderCircle } from "react-icons/lu";
import "../../../styles/ComponentsStyles/Universal/Loaders/ActivityLoader.style.css";
const ActivityLoader = () => {
  const { status, message } = LoaderState();
  return status ? (
    <div className="activityLoader">
      <LuLoaderCircle color="black" className="activityLoaderIcon" />
      <p className="poppins t-12 color-textColor">{message}</p>
    </div>
  ) : (
    ""
  );
};

export default ActivityLoader;
